export function getTrimmedMean(data, trimAmount) {
    const trimCount = Math.floor(trimAmount * data.length);
    const trimData = data.sort().slice(trimCount, data.length - trimCount);
    if (!trimData.length)
        return null;
    return trimData.reduce((a, b) => a + b, 0) / trimData.length;
}
